import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import { LightLogo } from '@/app/core/components/LightLogo';
import { Box, Flex } from '@chakra-ui/react';

type LoginPageProps = {
  isInternalLogin?: boolean;
  loginType?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
};

export const LoginPage = (props: LoginPageProps) => {
  const { isInternalLogin, children, loginType } = props;
  return (
    <Flex as='section' flexDir='column'>
      <Box
        as='header'
        h={16}
        lineHeight={16}
        className='main-header'
        px='6'
        shadow={'base'}
      >
        <LightLogo isInternalLogin={isInternalLogin} loginType={loginType} />
      </Box>
      <Box flex='auto' as='main'>
        {children}
      </Box>
    </Flex>
  );
};
